var _path, _path2, _g, _circle, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdcSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    width: "35px",
    height: "35px",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9328_141593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H25.411C21.6273 38.2608 19 34.4372 19 30C19 23.9249 23.9249 19 30 19C34.4372 19 38.2608 21.6273 40 25.411V0Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34.589C38.9028 36.976 36.976 38.9028 34.589 40H40V34.589Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9328_141593)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 0.000488281C27.1652 0.000488281 35 7.83533 35 17.5005C35 27.1649 27.1652 35.0005 17.5 35.0005C7.83483 35.0005 0 27.1649 0 17.5005C0 7.83533 7.83483 0.000488281 17.5 0.000488281Z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2203 29.3474C14.2203 29.7544 13.898 29.9856 13.5 29.8627C8.21025 28.1937 4.375 23.2881 4.375 17.4997C4.375 11.7116 8.21025 6.80568 13.5 5.1367C13.898 5.01459 14.2203 5.24504 14.2203 5.65206V6.65684C14.2203 6.92779 14.008 7.24672 13.7469 7.33501C9.56177 8.85494 6.56371 12.8314 6.56371 17.4928C6.56371 22.1543 9.56177 26.1315 13.7469 27.6507C14.008 27.7458 14.2203 28.0577 14.2203 28.3296V29.3474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5911 25.6084C18.5911 25.9072 18.3441 26.1515 18.0424 26.1515H16.9513C16.6495 26.1515 16.4026 25.9072 16.4026 25.6084V23.8987C14.0148 23.5799 12.8488 22.2564 12.5331 20.4585C12.478 20.1527 12.725 19.8747 13.0407 19.8747H14.2894C14.55 19.8747 14.7697 20.0581 14.8246 20.3155C15.058 21.3877 15.6823 22.2089 17.5962 22.2089C19.0096 22.2089 20.0116 21.4284 20.0116 20.2618C20.0116 19.0943 19.4213 18.6534 17.3493 18.3138C14.2894 17.9068 12.8419 16.9905 12.8419 14.6157C12.8419 12.7837 14.2417 11.3589 16.4095 11.0533V9.37727C16.4095 9.07859 16.6566 8.83418 16.9582 8.83418H18.0493C18.3511 8.83418 18.598 9.07859 18.598 9.37727V11.1009C20.3613 11.4136 21.4796 12.4036 21.8434 14.0456C21.9118 14.3583 21.6649 14.6495 21.3426 14.6495H20.1897C19.9428 14.6495 19.737 14.4865 19.6617 14.2491C19.3529 13.2046 18.598 12.7569 17.2875 12.7569C15.8399 12.7569 15.092 13.4489 15.092 14.419C15.092 15.4437 15.5177 15.959 17.7408 16.2785C20.7454 16.6856 22.2963 17.5336 22.2963 20.0652C22.2963 21.9853 20.8553 23.5392 18.598 23.8987V25.6084H18.5911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7797 29.3473C20.7797 29.7543 21.1024 29.9855 21.5 29.8627C26.7898 28.1868 30.6185 23.2878 30.625 17.5134C30.625 11.7253 26.7898 6.81957 21.5 5.1496C21.1024 5.0214 20.7797 5.25873 20.7797 5.66575V6.66974C20.7797 6.94167 20.9924 7.25353 21.2531 7.34869C25.4382 8.86863 28.4363 12.845 28.4363 17.5065C28.4363 22.168 25.4382 26.1444 21.2531 27.6643C20.965 27.7666 20.7797 28.0446 20.7797 28.3433V29.3473Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 10,
    fill: "#010101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3738 28.9949H33.3631C33.4632 28.9949 33.5581 29.0345 33.6272 29.105L34.8911 30.3723C35.1242 30.6061 34.9585 31.0051 34.6269 31.0051H26.6377C26.5376 31.0051 26.4427 30.9655 26.3735 30.895L25.1097 29.6277C24.8748 29.3939 25.0423 28.9949 25.3738 28.9949ZM25.1097 27.3149L26.3735 26.0475C26.4443 25.977 26.5393 25.9375 26.6377 25.9375H34.6252C34.9567 25.9375 35.1242 26.3364 34.8894 26.5703L33.6272 27.8376C33.5564 27.9082 33.4614 27.9477 33.3631 27.9477H25.3738C25.0423 27.9477 24.8748 27.5488 25.1097 27.3149ZM34.8894 32.6851L33.6255 33.9525C33.5547 34.023 33.4597 34.0625 33.3613 34.0625H25.3738C25.0423 34.0625 24.8748 33.6636 25.1097 33.4297L26.3735 32.1624C26.4443 32.0918 26.5393 32.0523 26.6377 32.0523H34.6252C34.9567 32.0523 35.1242 32.4512 34.8894 32.6851Z",
    fill: "url(#paint0_linear_9328_141593)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9328_141593",
    x1: 25.5693,
    y1: 34.4121,
    x2: 34.3933,
    y2: 25.5517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB4EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10F4B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdcSolana);
export default __webpack_public_path__ + "static/media/usdcSolana.9008fe10068250302a304b8bfab8c2d2.svg";
export { ForwardRef as ReactComponent };